import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SubscriptionCancelReason } from '../enums';
import { SubscriptionCancelReasonProviderService } from '../providers';

@Pipe({
  name: 'subscriptionCancelReason',
})
export class SubscriptionCancelReasonPipe implements PipeTransform {
  private readonly provider = inject(SubscriptionCancelReasonProviderService);

  public transform(reason: SubscriptionCancelReason): Observable<string> {
    return this.provider.labelFor(reason);
  }
}
